import { HOUR } from '@/libs/constants';
import { dateRegexp } from './constants';
const DEPARTURE_MIN_HOURS_FROM_NOW = 24;
export const FLIGHT_DEPARTURE_MIN_TIME_ERROR = 'Страхование возможно не позднее 24 часов до вылета.';
const timeRegexp = /^([01]\d|2[0-3]):([0-5]\d)$/;
const getDepartureDate = (dateFrom, timeFrom) => {
    if (!dateRegexp.test(dateFrom) || !timeRegexp.test(timeFrom)) {
        return null;
    }
    const [day, month, year] = dateFrom.split('.').map(Number);
    const [hours, minutes] = timeFrom.split(':').map(Number);
    return new Date(year, month - 1, day, hours, minutes);
};
export const validateFlightDeparture = ({ dateFrom, timeFrom, }) => {
    const departureDate = getDepartureDate(dateFrom, timeFrom);
    if (!departureDate) {
        return { error: null };
    }
    const minDepartureDate = new Date(Date.now() + DEPARTURE_MIN_HOURS_FROM_NOW * HOUR);
    if (departureDate < minDepartureDate) {
        return { error: FLIGHT_DEPARTURE_MIN_TIME_ERROR };
    }
    return { error: null };
};
